module.exports = __webpack_public_path__ + "static/img/feedback-form.48aaa961.png";